import React from 'react';
import { GoogleLogin } from '@react-oauth/google';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

function Login({ darkMode, onToggleDark }) {
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSuccess = (credentialResponse) => {
    login(credentialResponse);
    navigate('/dashboard');
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: darkMode ? '#0f172a' : '#f4f3ef',
      transition: 'background 0.3s',
    }}>
      {/* Dark mode toggle */}
      <button
        className="dark-toggle-btn"
        onClick={onToggleDark}
        style={{ position: 'fixed', top: 16, right: 16 }}
      >
        {darkMode ? '☀ Light Mode' : '☾ Dark Mode'}
      </button>

      <div style={{
        background: darkMode ? '#1e293b' : '#ffffff',
        border: `1px solid ${darkMode ? '#334155' : '#e8e8e8'}`,
        borderRadius: '12px',
        padding: '48px 40px',
        width: '100%',
        maxWidth: '400px',
        textAlign: 'center',
        boxShadow: '0 4px 24px rgba(0,0,0,0.08)',
        transition: 'background 0.3s, border-color 0.3s',
      }}>
        <div style={{
          width: 56, height: 56,
          background: '#4e73df',
          borderRadius: '14px',
          margin: '0 auto 20px',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontSize: 26,
        }}>
          T
        </div>
        <h2 style={{ color: darkMode ? '#e2e8f0' : '#1d2935', margin: '0 0 8px', fontWeight: 700, fontSize: 22 }}>
          Thomas PoC Dashboard
        </h2>
        <p style={{ color: darkMode ? '#64748b' : '#9a9a9a', marginBottom: 32, fontSize: 14 }}>
          Sign in with your Google account to continue
        </p>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <GoogleLogin
            onSuccess={handleSuccess}
            onError={() => console.error('Google login failed')}
            theme={darkMode ? 'filled_black' : 'outline'}
            size="large"
            shape="rectangular"
            text="signin_with"
          />
        </div>
      </div>
    </div>
  );
}

export default Login;
